import {Component, EventEmitter, inject, Output, signal} from '@angular/core';
import {FormControl, FormGroup, Validators} from "@angular/forms";
import {sign} from "chart.js/helpers";
import {RequestService} from "projects/store/src/app/services/api/v1/request.service";
import {UtilService} from "library";

@Component({
  selector: 'app-sales-pre-client-verification',
  templateUrl: './sales-pre-client-verification.component.html'
})
export class SalesPreClientVerificationComponent {
  @Output() nextStepEvent = new EventEmitter();
  form!: FormGroup;
  isSubmitted = signal<boolean>(false)
  requestService = inject(RequestService);
  private utilService = inject(UtilService)

  constructor() {
    this.form = new FormGroup({
      document_check: new FormControl(null, [Validators.required]),
      illuminated_site_check: new FormControl(null, [Validators.required]),
      selfie_ready_check: new FormControl(null, [Validators.required]),
    })
    this.requestService.step.set(3);
    this.utilService.disablePageLoading();
  }


  save(){
    this.isSubmitted.set(true);
    if (this.form.invalid) {
      return
    }

    this.onNextStep();


  }

  onNextStep() {
    this.nextStepEvent.emit();
  }
}
